import React from 'react';
import { Box } from "@mui/material";
import theme from "../../configs/theme";
import Note from "../containers/Note";
import CreateNote from "../containers/CreateNote";

export default function NotesTableUI({ notes, rol }) {
  return (
    <Box
      sx={{
        height: "100%",
        bgcolor: theme.tableColors.body,
        display: "flex",
        flexDirection: "column",
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          height: "7.5%",
          pl: 2,
          pt: 1,
          pb: 1,
          bgcolor: theme.tableColors.header,
          color: "black",
          alignContent: "center",
          fontWeight: "bold",
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
        }}
      >
        Notas
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          height: "72%",
          px: 1,
          py: 2,
          mr: 1,
        }}
      >
        {notes.map((note) => (
          <Note key={note.id} note={note} rol={rol} />
        ))}
      </Box>
      <CreateNote />
    </Box>
  );
}
